import { useMemo, useState } from "react";
import Tab from "@mui/material/Tab";
import TabPanel from "../TabPanel";
import {
  Alert,
  Badge,
  Box,
  Button,
  Chip,
  Divider,
  Paper,
  Stack,
  Tabs,
  Tooltip,
  Typography,
  alpha,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SelectedProducts from "../SelectedPresentation";
import PromoStoreCommerceImportDialog from "../PromoStoreCommerceImportDialog";
import styles from "./index.module.css";

const PresentationTabs = ({
  order,
  fetchOrder,
  handleShowProductsPopup,
  selectedProducts,
  isPromoStore = false,
  onOpenCartHistory = null,
  cartWorkspace = null,
  salesOrderCartUnlocked = false,
  onUnlockSalesOrderCart = null,
  onSavePromoStoreProduct = null,
  onWorkspaceMutationCommitted = null,
  onReorderProducts = null,
  onReorderLayout = null,
  secondaryActionLabel = "Add Title",
  onSecondaryAction = null,
  promoStoreCategories = [],
  canSeeManualPricingToggle = false,
  showcaseProductViewScope = null,
  showcaseActions = null,
  renderShowcaseToolbar = null,
  showcaseFooter = null,
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [commerceImportOpen, setCommerceImportOpen] = useState(false);
  const cartEditable = showcaseActions ? !showcaseActions.busy : cartWorkspace?.editable ?? true;

  // const safeProducts = useMemo(
  //   () => (Array.isArray(selectedProducts) ? selectedProducts : []),
  //   [selectedProducts],
  // );

  // const productCount = order?.ShowcasePagination ? Number(order.ShowcaseTotal || 0) : safeProducts.length;

  // const serviceCount = useMemo(() => {
  //   return safeProducts.filter((item) => {
  //     const type = String(
  //       item?.type ||
  //         item?.Type ||
  //         item?.priceType ||
  //         item?.productType ||
  //         item?.Source ||
  //         "",
  //     ).toLowerCase();

  //     return (
  //       type.includes("service") ||
  //       type.includes("custom") ||
  //       type.includes("fee") ||
  //       type.includes("charge")
  //     );
  //   }).length;
  // }, [safeProducts]);

  // const cartLabel = useMemo(() => {
  //   if (productCount === 0) return "Empty cart";
  //   if (productCount === 1) return "1 item in cart";
  //   return `${productCount} items in cart`;
  // }, [productCount]);



  const safeProducts = useMemo(
  () => (Array.isArray(order?.Products) ? order.Products : []),
  [order?.Products]
);

const safeServices = useMemo(
  () => (Array.isArray(order?.OtherService) ? order.OtherService : []),
  [order?.OtherService]
);

const productCount = safeProducts.length;
const serviceCount = safeServices.length;
const totalCount = productCount + serviceCount;

const cartLabel = useMemo(() => {
  if (totalCount === 0) return "Empty cart";
  if (totalCount === 1) return "1 item in cart";
  return `${totalCount} items in cart`;
}, [totalCount]);

  const handleChange = (_, newValue) => {
    setCurrentTab(newValue);
  };


  

  if (showcaseActions) return <SelectedProducts
    order={order} fetchOrder={fetchOrder} selectedProducts={selectedProducts}
    handleShowProductsPopup={handleShowProductsPopup} isPromoStore={isPromoStore}
    onOpenCartHistory={onOpenCartHistory} cartWorkspace={cartWorkspace}
    salesOrderCartUnlocked={salesOrderCartUnlocked} onUnlockSalesOrderCart={onUnlockSalesOrderCart}
    onSavePromoStoreProduct={onSavePromoStoreProduct} onWorkspaceMutationCommitted={onWorkspaceMutationCommitted}
    onReorderProducts={onReorderProducts} onReorderLayout={onReorderLayout}
    secondaryActionLabel={secondaryActionLabel} onSecondaryAction={onSecondaryAction}
    promoStoreCategories={promoStoreCategories} canSeeManualPricingToggle={canSeeManualPricingToggle}
    showcaseProductViewScope={showcaseProductViewScope} showcaseActions={showcaseActions}
    renderShowcaseToolbar={renderShowcaseToolbar} showcaseFooter={showcaseFooter}
  />;

  return (
    <Box
      className={styles.presentationTabContainer}
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      {isPromoStore && String(order?.StoreType || "").toLowerCase() === "pop_up_store" && (
        <Alert severity={order?.ExpiryDate ? "info" : "warning"} sx={{ borderRadius: 1 }}>
          {order?.ExpiryDate ? (
            <>
              <strong>Closing date: {String(order.ExpiryDate).slice(0, 10)}.</strong>{" "}
              Checkout closes at {order.ExpiryTime || "23:59"} in the company timezone.
              Elite Core sends that cutoff to WordPress when the store is synced.
            </>
          ) : (
            <>
              <strong>No closing date is set.</strong>{" "}
              This pop-up store will not automatically close until a closing date is set in Overview.
            </>
          )}
        </Alert>
      )}

      <Paper
        elevation={0}
        sx={{
          // borderRadius: 3,
          borderRadius: 1,
          border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.9)}`,
          overflow: "hidden",
          background: (theme) =>
            `linear-gradient(180deg, ${alpha(
              theme.palette.background.paper,
              1,
            )} 0%, ${alpha(
              theme.palette.grey[50],
              theme.palette.mode === "light" ? 0.65 : 0.08,
            )} 100%)`,
        }}
      >
        <Box
          sx={{
            px: { xs: 1.5, md: 2 },
            pt: { xs: 1.5, md: 2 },
            pb: 1.25,
          }}
        >
          <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", lg: "center" }}
            justifyContent="space-between"
          >
            <Stack spacing={1}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                flexWrap="wrap"
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    // borderRadius: 2,
                    borderRadius: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
                    color: "error.main",
                    flexShrink: 0,
                  }}
                >
                  <ShoppingCartIcon sx={{ fontSize: 20 }} />
                </Box>

                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      lineHeight: 1.15,
                      color: "text.primary",
                      fontSize: { xs: "1rem", md: "1.1rem" },
                    }}
                  >
                    Cart
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      mt: 0.25,
                      fontSize: "0.85rem",
                    }}
                  >
                    {showcaseActions ? 'Review products on this page.' : 'Review selected products, services, and cart activity before continuing.'}
                  </Typography>
                </Box>
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                flexWrap="wrap"
              >
                {!showcaseActions && <Chip
                  size="small"
                  icon={
                    <Inventory2OutlinedIcon
                      sx={{ fontSize: "16px !important" }}
                    />
                  }
                  label={cartLabel}
                  sx={{
                    height: 26,
                    fontWeight: 600,
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    color: "primary.main",
                    // borderRadius: 999,
                    borderRadius: 1,
                  }}
                />}

                {serviceCount > 0 && (
                  <Chip
                    size="small"
                    icon={
                      <AutoAwesomeIcon sx={{ fontSize: "16px !important" }} />
                    }
                    label={`${serviceCount} service${
                      serviceCount > 1 ? "s" : ""
                    }`}
                    sx={{
                      height: 26,
                      fontWeight: 600,
                      bgcolor: (theme) =>
                        alpha(theme.palette.warning.main, 0.1),
                      color: "warning.dark",
                      // borderRadius: 999,
                      borderRadius: 1,
                    }}
                  />
                )}

                {isPromoStore && (
                  <Chip
                    size="small"
                    label="Promo Store"
                    sx={{
                      height: 26,
                      fontWeight: 600,
                      // borderRadius: 999,
                      borderRadius: 1,
                    }}
                  />
                )}
              </Stack>
            </Stack>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              alignItems={{ xs: "stretch", sm: "center" }}
              justifyContent="flex-end"
              sx={{ flexShrink: 0 }}
            >
              {!!fetchOrder && (
                <Tooltip title="Refresh cart data" arrow>
                  <Button
                    variant="outlined"
                    color="inherit"
                    onClick={() => fetchOrder?.()}
                    startIcon={<RefreshIcon />}
                    sx={{
                      textTransform: "none",
                      // borderRadius: 2,
                      borderRadius: 1,
                      fontWeight: 600,
                      minHeight: 40,
                    }}
                  >
                    Refresh
                  </Button>
                </Tooltip>
              )}

              {isPromoStore && (
                <Tooltip title={showcaseActions ? "Store import is unavailable for Showcase. Use Add Product or Catalogues." : "Import products from a connected commerce store"} describeChild arrow>
                  <span tabIndex={showcaseActions ? 0 : undefined} aria-label={showcaseActions ? "Store import is unavailable for Showcase. Use Add Product or Catalogues." : undefined}>
                  <Button
                    variant="outlined"
                    onClick={() => setCommerceImportOpen(true)}
                    startIcon={<CloudDownloadIcon />}
                    disabled={!!showcaseActions || !cartEditable}
                    sx={{
                      textTransform: "none",
                      borderRadius: 1,
                      fontWeight: 600,
                      minHeight: 40,
                    }}
                  >
                    Import Store
                  </Button>
                  </span>
                </Tooltip>
              )}

              {!!onOpenCartHistory && (
                <Tooltip title="Open cart activity and snapshots" arrow>
                  <Button
                    variant="outlined"
                    onClick={onOpenCartHistory}
                    startIcon={
                      <Badge
                        color="error"
                        variant="dot"
                        overlap="circular"
                        // invisible={productCount === 0}
                        invisible={totalCount === 0}
                      >
                        <HistoryIcon />
                      </Badge>
                    }
                    sx={{
                      textTransform: "none",
                      // borderRadius: 2,
                      borderRadius: 1,
                      fontWeight: 600,
                      minHeight: 40,
                    }}
                  >
                    History
                  </Button>
                </Tooltip>
              )}

              <Button
                variant="contained"
                color="error"
                startIcon={<AddIcon />}
                onClick={handleShowProductsPopup}
                disabled={!cartEditable}
                sx={{
                  textTransform: "none",
                  // borderRadius: 2,
                  borderRadius: 1,
                  fontWeight: 700,
                  minHeight: 40,
                  boxShadow: "none",
                  px: 2,
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                Add Product
              </Button>
            </Stack>
          </Stack>

          <Divider sx={{ my: 1.5 }} />

          <Tabs
            value={currentTab}
            onChange={handleChange}
            aria-label="Cart tabs"
            variant="scrollable"
            allowScrollButtonsMobile
            className="presentation-tabs"
            sx={{
              minHeight: 44,
              "& .MuiTabs-indicator": {
                height: 3,
                // borderRadius: 999,
                borderRadius: 1,
                backgroundColor: "#c3171d",
              },
              "& .MuiTab-root": {
                minHeight: 44,
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.92rem",
                color: "text.secondary",
                px: 1.5,
                mr: 1,
                // borderRadius: 2,
                borderRadius: 1,
                transition: "all 0.18s ease",
              },
              "& .Mui-selected": {
                color: "#c3171d !important",
                backgroundColor: (theme) =>
                  alpha(theme.palette.error.main, 0.06),
              },
            }}
          >
            <Tab
              label={
                <Stack direction="row" spacing={1} alignItems="center">
                  <span>Products</span>
                  {!showcaseActions && <Chip
                    size="small"
                    label={productCount}
                    sx={{
                      height: 20,
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      bgcolor: "rgba(195, 23, 29, 0.08)",
                      color: "#c3171d",
                      "& .MuiChip-label": { px: 0.8 },
                    }}
                  />}
                </Stack>
              }
            />
          </Tabs>
        </Box>

        <TabPanel
          className="presentation-tab-content"
          value={currentTab}
          index={0}
        >
          <Box sx={{ px: { xs: 1.25, md: 1.5 }, pb: { xs: 1.25, md: 1.5 } }}>
            {/* {productCount === 0 && ( */}
            {totalCount === 0 && (
              <Alert
                severity="info"
                sx={{
                  mb: 1.5,
                  // borderRadius: 2,
                  borderRadius: 1,
                  alignItems: "center",
                }}
              >
                No cart items yet. Use <strong>Add Product</strong> to start
                building this cart.
              </Alert>
            )}

            <Paper
              className="presentation-tab-content-inner"
              elevation={0}
              sx={{
                p: { xs: 1, md: 1.5 },
                // borderRadius: 3,
                borderRadius: 1,
                border: (theme) =>
                  `1px solid ${alpha(theme.palette.divider, 0.9)}`,
                backgroundColor: "background.paper",
                overflow: "hidden",
              }}
            >
              <SelectedProducts
                order={order}
                fetchOrder={fetchOrder}
                selectedProducts={selectedProducts}
                handleShowProductsPopup={handleShowProductsPopup}
                isPromoStore={isPromoStore}
                onOpenCartHistory={onOpenCartHistory}
                cartWorkspace={cartWorkspace}
                salesOrderCartUnlocked={salesOrderCartUnlocked}
                onUnlockSalesOrderCart={onUnlockSalesOrderCart}
                onSavePromoStoreProduct={onSavePromoStoreProduct}
                onWorkspaceMutationCommitted={onWorkspaceMutationCommitted}
                onReorderProducts={onReorderProducts}
                onReorderLayout={onReorderLayout}
                secondaryActionLabel={secondaryActionLabel}
                onSecondaryAction={onSecondaryAction}
                promoStoreCategories={promoStoreCategories}
                canSeeManualPricingToggle={canSeeManualPricingToggle}
                showcaseProductViewScope={showcaseProductViewScope}
                showcaseActions={showcaseActions}
              />
            </Paper>
          </Box>
        </TabPanel>
      </Paper>
      {isPromoStore && (
        <PromoStoreCommerceImportDialog
          open={commerceImportOpen}
          onClose={() => setCommerceImportOpen(false)}
          promoStoreId={order?.id || order?.PromoStoreId}
          instanceUniqueId={order?.InstanceUniqueIds?.[0] || order?.instanceUniqueId || order?.InstanceUniqueId}
          onImported={fetchOrder}
        />
      )}
    </Box>
  );
};

export default PresentationTabs;
